import { render } from "./GameSocial.vue?vue&type=template&id=659d6878"
import script from "./GameSocial.vue?vue&type=script&lang=ts"
export * from "./GameSocial.vue?vue&type=script&lang=ts"
script.render = render

export default script